import { Stack } from "@mui/material";
import { useEffect } from "react";
import { useLocation } from "react-router";

const ScrollToTop = (props) => {
  const location = useLocation();
  const isCareerTestRoute = location.pathname === "/careers/test"
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return <Stack mt={!isCareerTestRoute && 11}>{props.children}</Stack>;
};

export default ScrollToTop;
